export const BonusConsts = {
    CashdropBonus: "Cashdrop Bonus",    
    FreeSpinBonus:"Free Spin",
    ActiveStatus: "Active",
    InActiveStatus: "InActive",
    ConsumedStatus: "Consumed",
    CancelledStatus:"Cancelled",
    ExpiredStatus:"Expired",
    ExchangeVertical: "Exchange",
    SportsVertical: "Sports",
    SportsIndia: "Sports India",
    CasinoVertical: "Casino",
    DepositBonus: "Deposit Bonus",
    CashbackBonus:"Cashback",
    WinningBoostBonus:"Winning Boost",
    Include: "Include",
    Exclude: "Exclude",
    BharatSportsBook: "Bharat Sportsbook",
    SportBookPlus: "Sportsbook Plus",
    AdjustedByAdmin: "Adjusted by admin",
    BonusCancelled:"CANCELLED"
}
